import Layout from "../include/layout";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import { useEffect, useState } from "react";
import $ from "jquery"
import Swal from "sweetalert2";
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.css'
import { Button, Col, Form, Row } from "react-bootstrap";
import AdminService from "../../services/AdminService";
import { useSelector } from "react-redux";

export default function ReversementPage() {

    //##########################/// METHODES ##########################///
    const [liste_auteurs, setListeAuteurs] = useState([])
    const [liste_periodiques, setListePeriodiques] = useState([])

    const [date_debut, setDateDebut] = useState('')
    const [date_fin, setDateFin] = useState('')
    const [auteurs, setAuteurs] = useState([])
    const [periodiques, setPeriodiques] = useState([])

    const [validationError, setValidationError] = useState({})
    const token = useSelector(state => state.auth.token)

    //get liste
    const fetchReversements = async () => {
        await AdminService.listeReversements(token).then((res) => {
            setListeAuteurs(res.data.liste_auteur)
            setListePeriodiques(res.data.liste_periodiques)
        }).catch(error => {
            console.log(error)
        })

    }

    ///Save form data
    const handleSubmit = async (event) => {
        event.preventDefault()
        let form = {
            date_debut, date_fin, auteurs , periodiques
        }

        await AdminService.reversement(form,token).then((response) => {
            if (response.status === 200) {
                //redirection sur index
                //navigate(myroutes.rubriques_index)
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            setValidationError(error.message)
        });
    }
    useEffect(() => {
        fetchReversements()
        $("#submenu-5").addClass("show")
    }, []) //Le crochet vide indique à React d'exécuter l'effet uen seule fois

    //##########################/// END METHODES ##########################///


    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0">Reversements</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item active">Reversements </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Reversements</h1>
                        </div>
                    </div>{/*//row*/}

                    <div className="app-card app-card-orders-table shadow-lg mb-5">
                        <div className="app-card-body mx-3 py-2">
                            <Row>
                                {
                                    Object.keys(validationError).length > 0 && (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="alert alert-danger">
                                                    <ul className="mb-0">
                                                        {
                                                            <li>{validationError}</li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </Row>
                            <Form className="mx-3 settings-form" style={{ textAlign: "left" }} onSubmit={handleSubmit}>

                                <Row>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Date debut <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info rounded-2" onChange={(e) => setDateDebut(e.target.value)}
                                                value={date_debut}
                                                name="date_debut"
                                                aria-label="date_debut"
                                                type="date"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Date fin <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info rounded-2 " onChange={(e) => setDateFin(e.target.value)}
                                                value={date_fin}
                                                name="date_fin"
                                                aria-label="date_fin"
                                                type="date"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={12} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Liste des médias éligibles  <i className="text-danger"></i>
                                            </Form.Label>
                                            <div style={{ backgroundColor: "#deeddd" }}>
                                                {liste_auteurs.length > 0 && liste_auteurs.map((item, id) => (
                                                    <div key={id} className="mb-3">
                                                        <Form.Check
                                                            inline
                                                            label={item.nom_auteur}
                                                            name={item.nom_auteur}
                                                            value={item.id}
                                                            onChange={(e) => setAuteurs(e.target.value)}
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <hr />
                                <Row>
                                    <Col md={12} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <div style={{ backgroundColor: "#deeddd" }}>
                                                {liste_periodiques.length > 0 && liste_periodiques.map((item, id) => (
                                                    <div key={id} className="mb-3">
                                                        <Form.Check
                                                            inline
                                                            label={item.get_editeur.raison_sociale}
                                                            name={item.get_editeur.raison_sociale}
                                                            value={item.id}
                                                            onChange={(e) => setPeriodiques(e.target.value)}
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Button type="submit" variant="primary">Enregistrer</Button>
                            </Form>
                            {/*//table-responsive*/}

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                    {/*//End table-content*/}



                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}